module.exports = __webpack_public_path__ + "img/screen_4_prompt.ba932983.png";